module.exports = __webpack_public_path__ + "img/agree.d26d7bba.png";